import { Routes } from '@angular/router';

import { advaniaServicesSegments } from '@advania-cosoftware/wolf-router';

export const secureIdentityRoutes: Routes = [
    {
        path: advaniaServicesSegments.secureIdentity,
        loadComponent: () =>
            import('./pages/secure-identity-page/secure-identity.page').then((m) => m.SecureIdentityPage),
    },
];
